(() => {
  let connected = false;
  let busy = false;
  let queued = null;
  let expectedVariant = null;
  const root = window.Shopify?.routes?.root || '/';
  const refresh = async () => {
    const footer = document.querySelector('#main-cart-footer');
    const section = footer?.dataset.id;
    if (!section) return;
    const response = await fetch(`${root}cart?section_id=${encodeURIComponent(section)}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Cart summary could not refresh');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    for (const selector of ['#main-cart-items .js-contents', '#main-cart-footer .js-contents-2']) {
      const current = document.querySelector(selector);
      const next = html.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }
  };
  const sync = async (checked) => {
    queued = checked;
    if (busy) return;
    busy = true;
    const footer = document.querySelector('#main-cart-footer');
    const controls = [...document.querySelectorAll('#main-cart-footer .cart__ctas, #main-cart-footer .icy-express, #main-cart-items')];
    controls.forEach(element => { element.inert = true; });
    footer?.setAttribute('aria-busy', 'true');
    try {
      while (queued !== null) {
        const enabled = queued;
        queued = null;
        const response = await fetch(`${root}cart.js`, { cache: 'no-store' });
        if (!response.ok) throw new Error('Cart could not load');
        const cart = await response.json();
        const updates = {};
        const protection = cart.items.filter(item => item.product_title === 'Order Protection');
        protection.forEach(item => { updates[item.variant_id] = 0; });
        if (enabled) {
          const variantId = expectedVariant?.id || protection[0]?.variant_id;
          if (!variantId) throw new Error('Protection price is not ready');
          updates[String(variantId).split('/').pop()] = 1;
        }
        if (Object.keys(updates).length) {
          const result = await fetch(`${root}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
          });
          if (!result.ok) throw new Error('Protection could not update');
        }
        await refresh();
      }
      const error = document.querySelector('#cart-errors');
      if (error) error.textContent = '';
      controls.forEach(element => { element.inert = false; });
    } catch (error) {
      const target = document.querySelector('#cart-errors');
      if (target) {
        target.setAttribute('role', 'alert');
        target.textContent = 'Your protection selection could not be updated. Please refresh your cart before checking out.';
      }
    } finally {
      busy = false;
      footer?.removeAttribute('aria-busy');
    }
  };
  const connect = () => {
    if (connected || !window.OrderProtection?.on) return;
    connected = true;
    window.OrderProtection.on('cart-updated', data => { expectedVariant = data.expectedVariant || expectedVariant; });
    window.OrderProtection.on('loaded', data => { expectedVariant = data.expectedVariant || expectedVariant; });
    window.OrderProtection.on('toggle', data => { sync(Boolean(data.checked)); });
  };
  connect();
  let attempts = 0;
  const timer = setInterval(() => {
    connect();
    if (connected || ++attempts >= 120) clearInterval(timer);
  }, 250);
})();
